<template>
  <div>
    <form role="form" @submit.stop.prevent="onSubmit">
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch
            color="success"
            v-model="formAgravoCep.status"
            style="width: 60px"
          >
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Tipo de Apólice</span>
          <v-select
            :options="listApolices"
            name="Tipo de Apólice"
            id="Tipo de Apólice"
            v-model="formAgravoCep.idTipoApolice"
            :reduce="(item) => item.id"
            v-validate="{ required: true }"
            placeholder="Selecione"
            :state="validateState(veeFields, veeErrors, 'Tipo de Apólice')"
            :class="validateStateClass(veeFields, veeErrors, 'Tipo de Apólice')"
          ></v-select>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Negar Proposta</span>
          <vs-switch
            color="success"
            v-model="formAgravoCep.negarProposta"
            style="width: 60px"
          >
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
      </div>
      <div v-if="!formAgravoCep.negarProposta" class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Porcentagem</span>
          <vs-input
            class="w-full"
            type="number"
            step="0.00001"
            icon-pack="feather"
            icon="icon-percent"
            v-model="formAgravoCep.porcentagem"
            id="Porcentagem"
            name="Porcentagem"
            v-validate="'required|between:0,100'"
            :state="validateState(veeFields, veeErrors, 'Porcentagem')"
            :class="validateStateClass(veeFields, veeErrors, 'Porcentagem')"
          />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Faixa Inicial</span
          ><vs-input
            class="w-full"
            v-model="formAgravoCep.faixaInicial"
            id="Faixa Inicial"
            name="Faixa Inicial"
            :state="validateState(veeFields, veeErrors, 'Faixa Inicial')"
            :class="validateStateClass(veeFields, veeErrors, 'Faixa Inicial')"
            v-mask="'##.###-###'"
            icon-pack="feather"
            icon="icon-home"
            icon-no-border
          />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Faixa Final</span
          ><vs-input
            class="w-full"
            v-model="formAgravoCep.faixaFinal"
            id="Faixa Final"
            name="Faixa Final"
            :state="validateState(veeFields, veeErrors, 'Faixa Final')"
            :class="validateStateClass(veeFields, veeErrors, 'Faixa Final')"
            v-mask="'##.###-###'"
            icon-pack="feather"
            icon="icon-home"
            icon-no-border
            :disabled="disabledFaixaFinal"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col mb-6">
          <vs-checkbox v-model="rua">Rua em vez de intervalo</vs-checkbox>
        </div>
      </div>

      <ErrorsAlert :errors="errors" />

      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="dados == null ? false : true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import vSelect from 'vue-select';
import BotaoSubmit from '../../../../components/BotaoSubmit.vue';
import ErrorsAlert from '../../../../components/ErrorsAlert.vue';

import service from '../../../../services';
import utilsList from '../../../../utils/list/index';
import functions from '../../../../utils/functions';
import notify from '../../../../utils/notify';

export default {
  name: 'form-agravos-cep',
  components: {
    BotaoSubmit,
    'v-select': vSelect,
    ErrorsAlert,
  },
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
  },
  watch: {
    dados() {
      this.preencheForm();
    },
    rua(newValue) {
      if (newValue) {
        this.formAgravoCep.faixaFinal = this.formAgravoCep.faixaInicial;
      }
    },
  },
  computed: {
    errors() {
      return this.$validator.errors.all();
    },
    disabledFaixaFinal() {
      return this.rua ? true : false;
    },
  },
  data() {
    return {
      validateState: utilsList.validateState,
      validateStateClass: utilsList.validateStateClass,
      aguardeCadastro: false,
      rua: false,
      formAgravoCep: {
        idAgravoCep: null,
        status: false,
        idTipoApolice: null,
        porcentagem: null,
        faixaInicial: null,
        faixaFinal: null,
        negarProposta: false,
      },
      listApolices: [],
    };
  },
  mounted() {
    this.getDominios();
  },
  methods: {
    preencheForm() {
      if (this.dados === null) {
        this.resetForm();
        return;
      }

      this.formAgravoCep.idAgravoCep = this.dados.idAgravoCep;
      this.formAgravoCep.status = this.dados.deletedAt ? false : true;
      this.formAgravoCep.idTipoApolice = this.dados.idTipoApolice;
      this.formAgravoCep.porcentagem = this.dados.porcentagem;
      this.formAgravoCep.faixaInicial = this.dados.faixaInicial;
      this.formAgravoCep.faixaFinal = this.dados.faixaFinal;
      this.formAgravoCep.negarProposta = this.dados.negarProposta
        ? this.dados.negarProposta
        : false;
    },
    getDominios() {
      try {
        if (this.listApolices.length === 0) {
          functions.buscaDadosSelects(
            'tipoApolices',
            this.listApolices,
            'nome',
            'tipoApoliceId',
          );
        }
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      }
    },
    onReset() {
      this.resetForm();
      this.$emit('cancel');
    },
    resetForm() {
      this.formAgravoCep = {
        idAgravoCep: null,
        status: false,
        idTipoApolice: null,
        porcentagem: null,
        faixaInicial: null,
        faixaFinal: null,
        negarProposta: false,
      };
    },
    async onSubmit() {
      const validated = await this.$validator.validateAll();
      if (!validated) {
        return;
      }

      if (this.formAgravoCep.negarProposta && !this.formAgravoCep.porcentagem) {
        this.formAgravoCep.porcentagem = 0;
      }

      try {
        this.$vs.loading();
        await service.post('agravos', 'agravos-cep', this.formAgravoCep);

        notify.notifySuccess(this.$vs, 'Operação realizada com sucesso!');

        this.resetForm();
        this.$emit('concluido');
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
  },
};
</script>
<style lang="scss"></style>
